import React from "react";
import "./signin-overlay.scss";
import CommonModal from "../../components/common-modal/common-modal";
import infinite from "../../static/Infinte.png";
import birthdayIcon from "../../static/Birthday.png";
import offersIcon from "../../static/offers.png";
import watch from "../../static/Watch.png";
import showPasswordEye from "../../static/show-password-eye.svg";
import passwordDontShowEye from "../../static/dont-show-password-eye.svg";
import MainLink from "../../components/main-link/main-link";
import MainButton from "../../components/main-button/main-button";
import ErrorMessage from "../../components/error-message-label/error-message-label";
import SquareCheckbox from "../../components/checkbox-square/checkbox-square";
import CoachInputField from "../../components/coach-input-box/coach-input-box";
import { login, getPersonalizedPromos } from "../../actions/account";
import Util from '../../utils/util';
import { connect } from "react-redux";

class SignInOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rememberMe: true,
      showPassword: false,
      invalidEmail: false,
      invalidPassword: false,
      email: "",
      password: "",
      passwordLength: 0,
      passwordValidationFailed: false
    };
    this.insiderGateType = Util.getInsiderGateGroup();
  }
  
  componentDidMount() {
    const needToRemember = Util.getStringFromStorage(Util.NEED_REMEMBER_USER) || "false";
    const userDetail = Util.getLoggedInUserDetails() || {};
    if (needToRemember == 'true' && userDetail && userDetail.email) {
      this.setState({ email: userDetail.email });
    }
    
    if (this.insiderGateType === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE) {
      dataLayer.push({
          'event': 'appPageView',
          'appPageName': 'home: gwp welcome back insider',
          'flowConfig': Util.getGAFlowConfig()
      });
  } else if (this.insiderGateType === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_NO_INCENTIVE) {
      dataLayer.push({
          'event': 'appPageView',
          'appPageName': 'home: non-gwp welcome back insider',
          'flowConfig': Util.getGAFlowConfig()
      });
  }
  }

  getPromotionText = () => {

    let common = {};

    if (this.props.locale && this.props.locale.screens) {
      common = this.props.locale.screens.common;
    }

    switch(this.insiderGateType) {
      case Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE:
        return common.signinForGWP;

      case Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_NO_INCENTIVE:
        return common.signinWithoutGWP;

      default:
        return null;
    }
  }

  updateEmailState = (e) => {
    this.setState({ email: e.target.value });
  };

  changeCheckboxState = () => {
    this.setState((prevState, props) => {
      return {
        rememberMe: !prevState.rememberMe,
      };
    });
  };

  changeShowPasswordState = () => {
    this.setState((prevState, props) => {
      return {
        showPassword: !prevState.showPassword,
      };
    });
  };

  updatePasswordLengthState = (e) => {
    this.setState({
      ...this.state,
      password: e.target.value,
      passwordLength: e.target.value.length,
    });
  };

  onForgotPasswordClick = () => {
    window.open(Util.FORGOT_PASSWORD_LINK, "_blank");
  };

  emailBlurHandler = () => {
    this.state.email && Util.isValidEmail(this.state.email)
      ? this.setState({ invalidEmail: false })
      : this.setState({ invalidEmail: true });
  };

  isLoginDetailsValid = () => {
    let isValid = false;
    if (
      Util.isValidEmail(this.state.email) &&
      Util.isValidPassword(this.state.password)
    ) {
      isValid = true;
    }
    return isValid;
  };

  onPasswordFieldBlur = () => {
    if (!this.state.password) {
      this.setState({passwordValidationFailed: true});
    } else {
      this.setState({passwordValidationFailed: false});
    }
  }

  render() {
    let accountLogin = {};
    let common = {};
    const { onSignUpClick } = this.props;

    if (this.props.locale && this.props.locale.screens) {
      accountLogin = this.props.locale.screens.login;
      common = this.props.locale.screens.common;
    }

    return (
      <CommonModal enableCloseButton={false} className="signin-overlay-wrapper">
        <h2 className="heading"> {accountLogin.welcomeBack} <br/> <i>{common.in}</i>{common.siderWithoutExclamation} </h2>
        <span className="body">
          { this.getPromotionText() }
        </span>
        <div className="rewardsBox">
          <div className="rewardsIcon">
            <img alt="" className="" src={watch} />
            <span> {common.earlyAccess} </span>
          </div>
          <hr />
          <div className="rewardsIcon">
            <img alt="" className="" src={offersIcon} />
            <span> {common.personalizedOffers} </span>
          </div>
          <hr />
          <div className="rewardsIcon">
            <img alt="" className="" src={birthdayIcon} />
            <span> {common.birthdayRewards} </span>
          </div>
          <hr />
          <div className="rewardsIcon">
            <img alt="" className="infinite" src={infinite} />
            <span> {common.andManyMore} </span>
          </div>
        </div>
        <div className="action-container">
          <div className="action-container-section">
            <CoachInputField
              type="email"
              placeholder={common.email}
              id="email-input"
              change={this.updateEmailState}
              blur={this.emailBlurHandler}
              value={this.state.email}
              hasError={this.state.invalidEmail}
              withBorder={true}
            />
            {this.state.invalidEmail ? (
              <ErrorMessage
                label={common.enterValidEmail}
                show="true"
              />
            ) : (
              ""
            )}
          </div>
          <div className="action-container-section">
            <div className="password-box-container">
              {/* <MainInput
                            type={this.state.showPassword ? "text" : "password"}
                            placeholder={accountLogin.passwordPlaceholder}
                            id="password-input"
                            onChange={this.updatePasswordLengthState}
                        /> */}
              <CoachInputField
                placeholder={accountLogin.passwordPlaceholder}
                showPassword={this.state.showPassword}
                showIcon={showPasswordEye}
                dontShowIcon={passwordDontShowEye}
                click={this.changeShowPasswordState}
                change={this.updatePasswordLengthState}
                hasError={this.state.invalidPassword || this.state.passwordValidationFailed}
                withBorder={true}
                blur={this.onPasswordFieldBlur}
                // value={this.state.currentPassword}
              />
              {/* <div className="show-password">
                            <img
                            src={
                                this.state.showPassword
                                ? showPasswordEye
                                : passwordDontShowEye
                            }
                            onClick={this.changeShowPasswordState}
                            />
                        </div> */}
            </div>
            {this.state.passwordValidationFailed ? (
              <ErrorMessage
                aria-live="assertive"
                label={accountLogin.passwordBlankErrorMessage}
                show={true}
              />
            ) : (
              ""
            )}
            {this.state.invalidPassword ? (
              <ErrorMessage
                aria-live="assertive"
                label={accountLogin.passwordErrorMessage}
                show={true}
              />
            ) : (
              ""
            )}
          </div>
          <div className="password-container-bottom-bar">
            <SquareCheckbox
              checked={this.state.rememberMe}
              label={accountLogin.rememberMe}
              click={this.changeCheckboxState}
            />

            <div className="forgot-password-container">
              <MainLink onClick={this.onForgotPasswordClick}>
                {accountLogin.forgotPassword}
              </MainLink>
            </div>
          </div>
          <div className="button-container">
            <MainButton
              className={!this.isLoginDetailsValid() ? "disabled" : ""}
              onClick={this.onSignInClick}
              text={common.signIn}
              // disabled={
              //   !(
              //     Util.isValidEmail(this.state.email) &&
              //     this.state.passwordLength >= 4
              //   )
              // }
            ></MainButton>
          </div>
          <div className="not-a-member-container">
            <span>{accountLogin.notAMember}</span>
            <MainLink onClick={onSignUpClick}>
              {accountLogin.signup}
            </MainLink>
          </div>
        </div>
      </CommonModal>
    );
  }

  onSignInClick = () => {
    const { email, password, rememberMe } = this.state;
    const { onSignInSuccess } = this.props;
    if (
      Util.isValidEmail(this.state.email) &&
      Util.isValidPassword(this.state.password)
    ) {
      this.props.login(email, password, rememberMe).then(data => {
        if (data && data.customer_id && data.token) {
          onSignInSuccess();
          const referrerScreen = Util.getCookie(
            Util.COOKIE_NAMES.PREVIOUS_PAGE
          );
          // const queryParamsObj = Util.getQueryParams();
          //   if (queryParamsObj && queryParamsObj.source) {
              dataLayer.push({
                event: 'membershipInteraction',   
                membershipEventType:'login',  
                membershipEventTitle:'login successful',  
                membershipEventCTA:'login successful', 
                membershipEventAction:'submit', 
                membershipEventLocation:this.insiderGateType === Util.INSIDER_GATE_GROUPS.WITH_INSIDER_GATE_AND_INCENTIVE ? 'gwp sign-in':'non gwp sign-in', 
                rememberMeOption:rememberMe?'checked':'unchecked',
                rememberMe:'prepopulated', 
                userId: Util.getEmailId()
              });
            // } 
            // else {
              // dataLayer.push({
              //   event: 'customerCapture',    
              //   userCaptureAction: 'login', 
              //   userID: Util.getEmailId()
              // });
            // }
          if (referrerScreen) {
            const urlParams = Util.getQueryParams();
            if (
              urlParams &&
              Object.keys(urlParams).length > 0 &&
              urlParams["apply-promo"]
            ) {
              Util.addStringToStorage(
                Util.ADDITIONAL_APPLIED_COUPON,
                urlParams["apply-promo"]
              );
            }
            Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);
            // dataLayer.push({
            //   event: 'signInCapture',    
            //   userCaptureAction: 'member sign in', 
            //   userID: Util.getEmailId(),
            //   eventCallback: () => {
                Util.gotoRoute(referrerScreen, this.props.history);
            //   },
            //   eventTimeout: 2000
            // });
          } else {
            this.performPostSignInOperations();
          }
        }
        if (
          data &&
          data.fault &&
          data.fault.type &&
          data.fault.type === "AuthenticationFailedException"
        ) {
          this.setState({ invalidPassword: true });
        }
      });
    } else {
      if (
        !Util.isValidEmail(this.state.email) &&
        !Util.isValidPassword(this.state.password)
      ) {
        this.setState({
          invalidEmail: true,
          invalidPassword: true
        });
      } else if (
        !Util.isValidEmail(this.state.email) &&
        Util.isValidPassword(this.state.password)
      ) {
        this.setState({
          invalidEmail: true,
          invalidPassword: false
        });
      } else if (
        Util.isValidEmail(this.state.email) &&
        !Util.isValidPassword(this.state.password)
      ) {
        this.setState({
          invalidEmail: false,
          invalidPassword: true
        });
      } else {
        this.setState({
          invalidEmail: true,
          invalidPassword: true
        });
      }
    }
  }

  performPostSignInOperations = () => {
    Util.removeFromSessionStorage(Util.PERSONALIZED_PROMO_LIST);
    Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_ID);
    Util.removeFromSessionStorage(Util.PRODUCT_LIST_LOADED_COUNT);
    Util.removeFromSessionStorage(Util.PRODUCT_LIST_SCROLL_POSITION_FOR_PDP);
    Util.clearCookie(Util.COOKIE_NAMES.PREVIOUS_PAGE);


    this.props.getPersonalizedPromos().then(data => {
      let personalizedPromosList = [];
      if (data && data.personalizedPromosList) {
        personalizedPromosList = data.personalizedPromosList;
      }
      Util.addObjectToSessionStorage(Util.PERSONALIZED_PROMO_LIST, personalizedPromosList);
    });
  }
}

const mapStateToProps = state => {
    return {
      locale: state.locale
    };
};

const mapDispatchToProps = dispatch => {
    return {
      login: (email, password, rememberMe) => dispatch(login(email, password, rememberMe)),
      getPersonalizedPromos: () => dispatch(getPersonalizedPromos())
    };
};
  
const connectedSignInOverlay = connect(mapStateToProps, mapDispatchToProps)(SignInOverlay);
  
export default connectedSignInOverlay;

